import Textarea from "@mui/joy/Textarea";
import {
  Autocomplete,
  Box,
  Button,
  Chip,
  CircularProgress,
  FormControl,
  Grid,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { getListUser } from "entities/report_revenue/service";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { FaUpload } from "react-icons/fa";
import { useListData } from "hooks/useListData";
import tiers from "../service/tiers.json";
const CreateCourse = ({
  handleImageClickOneOne,
  mediaSrcVideo,
  mediaSrcImage,
  handleFileChangeAndUploadCallVideo,
  showUploadButtonImage,
  showUploadButtonVideo,
  loadingCirImage,
  loadingCirVideo,
  handleFileChangeAndUploadCallOneOne,
  handleSubmit,
  handleChangeCourse,
  formData,
  handleChangeSkills,
}) => {
  const skillsOptions = ["Listening", "Reading", "Writing", "Speaking"];

  useEffect(() => {
    const handleResizeError = (e) => {
      if (e.message === "ResizeObserver loop limit exceeded") {
        const overlay = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        const overlayDiv = document.getElementById(
          "webpack-dev-server-client-overlay-div"
        );

        if (overlay) {
          overlay.style.display = "none";
        }
        if (overlayDiv) {
          overlayDiv.style.display = "none";
        }
      }
    };

    window.addEventListener("error", handleResizeError);

    return () => {
      window.removeEventListener("error", handleResizeError);
    };
  }, []);

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: 224,
        width: 250,
      },
    },
  };
  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "900px",
        height: "100%",
        margin: "0 auto",
        padding: 2,
        bgcolor: "#F1F1F1",
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Box sx={{ width: "100%" }}>
            <Box
              p={2}
              bgcolor="#fff"
              borderRadius={4}
              boxShadow="rgba(0, 0, 0, 0.16) 0px 1px 4px"
              mb={2}
            >
              <SelectTeacher
                handleChangeCourse={handleChangeCourse}
                formData={formData}
              />
            </Box>
            <Box
              p={2}
              bgcolor="#fff"
              borderRadius={4}
              boxShadow="rgba(0, 0, 0, 0.16) 0px 1px 4px"
              mb={2}
            >
              <Stack direction="column" gap={0.5}>
                <Typography variant="body2">Tiêu đề</Typography>
                <TextField
                  value={formData.title}
                  onChange={(e) => handleChangeCourse("title", e.target.value)}
                  name="title"
                  fullWidth
                  placeholder="Điền tiêu đề"
                  size="small"
                  sx={{
                    mb: 2,
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "12px !important",
                      fontSize: 14,
                    },
                  }}
                />
              </Stack>
              <Stack direction="column" gap={0.5}>
                <Typography variant="body2">Mô tả</Typography>
                <Textarea
                  color="neutral"
                  value={formData.description}
                  onChange={(e) =>
                    handleChangeCourse("description", e.target.value)
                  }
                  name="description"
                  minRows={3}
                  placeholder="Mô tả"
                  sx={{
                    mb: 2,
                    borderRadius: "12px",
                    bgcolor: "#fff",
                    fontSize: 14,
                    border: "1px solid #ccc",
                    padding: "8px",
                    "&:focus": {
                      borderColor: "#1976d2",
                    },
                  }}
                />
              </Stack>
              <Stack direction="column" gap={0.5}>
                <Typography variant="body2">Chi tiết khóa học</Typography>
                <Textarea
                  color="neutral"
                  value={formData.long_description}
                  onChange={(e) =>
                    handleChangeCourse("long_description", e.target.value)
                  }
                  name="long_description"
                  minRows={5}
                  placeholder="Chi tiết khóa học"
                  sx={{
                    mb: 2,
                    borderRadius: "12px",
                    bgcolor: "#fff",
                    fontSize: 14,
                    border: "1px solid #ccc",
                    padding: "8px",
                    "&:focus": {
                      borderColor: "#1976d2",
                    },
                  }}
                />
              </Stack>
            </Box>

            <Box
              p={2}
              bgcolor="#fff"
              borderRadius={4}
              boxShadow="rgba(0, 0, 0, 0.16) 0px 1px 4px"
              mb={2}
            >
              <Box
                display="flex"
                flexDirection="row"
                alignItems="center"
                gap={2}
                mb={2}
              >
                <Box flex={1}>
                  <Typography variant="body2" mb={0.5}>
                    Kiểu khóa học
                  </Typography>
                  <FormControl fullWidth>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={formData.type}
                      onChange={(e) =>
                        handleChangeCourse("type", e.target.value)
                      }
                      name="type"
                      fullWidth
                      size="small"
                      sx={{
                        height: 37,
                        fontSize: 14,
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "12px",
                          minHeight: "36px",
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderRadius: "12px",
                        },
                        "& .MuiSelect-select": {
                          padding: "6px 12px",
                        },
                      }}
                    >
                      <MenuItem value="Self-learning">Tự học</MenuItem>
                      <MenuItem value="Call 1-1">Gọi 1-1</MenuItem>
                      <MenuItem value="Call group">Gọi nhóm</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
                <Box>
                  {formData.type === "Call 1-1" ? (
                    <Box flex={1}>
                      <Typography variant="body2" mb={0.5}>
                        Giá khóa học
                      </Typography>
                      <TextField
                        fullWidth
                        value={formData.price}
                        onChange={(e) =>
                          handleChangeCourse("price", e.target.value)
                        }
                        name="price"
                        placeholder="Giá khóa học(VND)"
                        size="small"
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "12px !important",
                            fontSize: 14,
                          },
                        }}
                      />
                    </Box>
                  ) : (
                    <Box flex={1}>
                      <Typography variant="body2" mb={0.5}>
                        Giá khóa học(VND):
                      </Typography>
                      <FormControl fullWidth size="small">
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={formData.price}
                          onChange={(e) =>
                            handleChangeCourse("price", e.target.value)
                          }
                          name="price"
                          fullWidth
                          size="small"
                          sx={{
                            height: 37,
                            fontSize: 14,
                            "& .MuiOutlinedInput-root": {
                              borderRadius: "12px",
                              minHeight: "36px",
                            },
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderRadius: "12px",
                            },
                            "& .MuiSelect-select": {
                              padding: "6px 12px",
                            },
                          }}
                        >
                          {tiers.map((tier) => (
                            <MenuItem key={tier.id} value={tier.value}>
                              {tier.label} VND
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Box>
                  )}
                </Box>
              </Box>
              <Stack
                gap={2}
                direction="row"
                justifyContent="center"
                alignItems="center"
              >
                <Box sx={{ mb: 2 }} flex={1}>
                  <Typography variant="body2" mb={0.5}>
                    Kĩ năng
                  </Typography>
                  <FormControl fullWidth>
                    <Select
                      id="demo-multiple-chip"
                      multiple
                      value={formData.skills || []}
                      onChange={handleChangeSkills}
                      input={<OutlinedInput />}
                      renderValue={(selected) => (
                        <Box
                          sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}
                        >
                          {Array.isArray(selected) ? (
                            selected.map((value) => (
                              <Chip key={value} size="small" label={value} />
                            ))
                          ) : (
                            <Chip key={selected} label={selected} />
                          )}
                        </Box>
                      )}
                      MenuProps={MenuProps}
                      size="small"
                      sx={{
                        height: 37,
                        fontSize: 14,
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "12px",
                          minHeight: "36px",
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderRadius: "12px",
                        },
                        "& .MuiSelect-select": {
                          padding: "6px 12px",
                        },
                      }}
                    >
                      {skillsOptions.map((skill) => (
                        <MenuItem key={skill} value={skill}>
                          {skill}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>

                <Box sx={{ mb: 2 }} flex={1}>
                  <Typography variant="body2" mb={0.5}>
                    Cấp độ
                  </Typography>
                  <FormControl fullWidth>
                    <Select
                      id="level-select"
                      value={formData.level}
                      onChange={(e) =>
                        handleChangeCourse("level", e.target.value)
                      }
                      name="level"
                      fullWidth
                      size="small"
                      sx={{
                        height: 37,
                        fontSize: 14,
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "12px",
                          minHeight: "36px",
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderRadius: "12px",
                        },
                        "& .MuiSelect-select": {
                          padding: "6px 12px",
                        },
                      }}
                    >
                      <MenuItem value="band_0_2">0 - 2.0+ IELTS</MenuItem>
                      <MenuItem value="band_2_4">2.0 - 4.0+ IELTS</MenuItem>
                      <MenuItem value="band_4_5">4.0 - 5.0+ IELTS</MenuItem>
                      <MenuItem value="band_5_6">5.0 - 6.0+ IELTS</MenuItem>
                      <MenuItem value="band_6_7">6.0 - 7.0+ IELTS</MenuItem>
                      <MenuItem value="band_7_5">7.5+ IELTS</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              </Stack>
            </Box>

            <Stack direction="row" gap={2} alignItems="center">
              {/* <Box flex={1}>
              <Typography variant="body1" fontWeight={550} mb={1}>
                Giá khóa học(Coin):
              </Typography>
              <TextField
                fullWidth
                type="text"
                value={formData.coin_price}
                onChange={(e) =>
                  handleChangeCourse("coin_price", e.target.value)
                }
                name="coin_price"
                placeholder="Giá khóa học(coin)"
                size="small"
              />
            </Box> */}
            </Stack>

            <Box
              p={2}
              bgcolor="#fff"
              borderRadius={4}
              boxShadow="rgba(0, 0, 0, 0.16) 0px 1px 4px"
              mb={2}
            >
              {formData.type === "Call 1-1" && (
                <Stack direction="row" justifyContent="space-between" mb={2}>
                  <Stack direction="column">
                    <Typography variant="body2" mb={0.5}>
                      Số ngày học:
                    </Typography>
                    <TextField
                      value={formData.lession_count}
                      onChange={(e) =>
                        handleChangeCourse("lession_count", e.target.value)
                      }
                      name="lession_count"
                      fullWidth
                      placeholder="Điền số ngày"
                      size="small"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "12px !important",
                          fontSize: 14,
                        },
                      }}
                    />
                  </Stack>
                  <Stack direction="column">
                    <Typography variant="body2" mb={0.5}>
                      Số giờ học:
                    </Typography>
                    <TextField
                      value={formData.class_duration}
                      onChange={(e) =>
                        handleChangeCourse("class_duration", e.target.value)
                      }
                      name="class_duration"
                      fullWidth
                      placeholder="Điền số giờ: 0.5 - 1 - 2"
                      size="small"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "12px !important",
                          fontSize: 14,
                        },
                      }}
                    />
                  </Stack>
                </Stack>
              )}

              <Stack direction="column">
                <Typography variant="body2" mb={0.5}>
                  Thời gian học:
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <Stack
                    direction="row"
                    alignItems="center"
                    gap={2}
                    justifyContent="space-between"
                  >
                    <input
                      type="date"
                      name="start_time"
                      onChange={(e) =>
                        handleChangeCourse("start_time", e.target.value)
                      }
                      placeholder="Chọn ngày bắt đầu"
                      style={{
                        width: "100%",
                        padding: "10px",
                        borderRadius: "12px",
                        border: "1px solid #ccc",
                      }}
                    />
                    <input
                      type="date"
                      name="end_time"
                      onChange={(e) =>
                        handleChangeCourse("end_time", e.target.value)
                      }
                      placeholder="Chọn ngày kết thúc"
                      style={{
                        width: "100%",
                        padding: "10px",
                        borderRadius: "12px",
                        border: "1px solid #ccc",
                      }}
                    />
                  </Stack>
                </LocalizationProvider>
              </Stack>
            </Box>

            {/* <Stack direction='column' gap={1} mb={2}>
                    <Typography variant='body1' fontWeight={550}>Thời gian học:</Typography>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Stack direction="row" alignItems="center" gap={2} justifyContent="space-between">
                            <DatePicker 
                                className='datePicker' 
                                onChange={(date) => handleChangeCourse("start_time", date)}
                                name="start_time"
                                slotProps={{ textField: { placeholder: 'Chọn ngày bắt đầu' } }}
                                sx={{ width: '100%' }}/>
                            <DatePicker 
                                className='datePicker' 
                                onChange={(date) => handleChangeCourse("end_time", date)}
                                name="end_time"
                                slotProps={{ textField: { placeholder: 'Chọn ngày kết thúc' } }}
                                sx={{ width: '100%' }}/>
                        </Stack>
                    </LocalizationProvider>
                </Stack> */}
          </Box>
        </Grid>
        <Grid item xs={12} md={5}>
          <Stack direction="column" gap={2} width="100%">
            <Box
              p={2}
              bgcolor="#fff"
              borderRadius={4}
              boxShadow="rgba(0, 0, 0, 0.16) 0px 1px 4px"
              mb={2}
            >
              <Box sx={{ width: "100%" }}>
                <Typography variant="body2" fontWeight={550} mb={2}>
                  Hình ảnh giới thiệu khóa học:
                </Typography>
                {loadingCirImage ? (
                  <CircularProgress />
                ) : (
                  <>
                    {mediaSrcImage && (
                      <Box
                        sx={{
                          position: "relative",
                          display: "inline-block",
                          width: "100%",
                          "&:hover .hoverText": {
                            opacity: 1,
                          },
                        }}
                        onClick={handleImageClickOneOne}
                      >
                        <Typography
                          variant="body2"
                          className="hoverText"
                          sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            zIndex: 1,
                            opacity: 0,
                            transition: "opacity 0.3s",
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "20px",
                            color: "#fff",
                            fontWeight: "bold",
                            backgroundColor: "rgba(0, 0, 0, 0.5)",
                            cursor: "pointer",
                          }}
                        >
                          Thay đổi hình ảnh
                        </Typography>
                        <img
                          src={mediaSrcImage}
                          alt="Media preview"
                          width="100%"
                          style={{ cursor: "pointer" }}
                        />
                      </Box>
                    )}
                  </>
                )}
                {showUploadButtonImage && (
                  <Button
                    component="label"
                    variant="contained"
                    startIcon={<FaUpload />}
                    sx={{
                      width: "100%",
                      height: "150px",
                      background: "transparent",
                      borderRadius: 2,
                      color: "#333",
                      fontWeight: 550,
                      border: "1px dashed",
                      marginBottom: 2,
                      "&:hover": {
                        backgroundColor: "rgba(0,0,0,0.1)",
                      },
                    }}
                  >
                    Tải ảnh
                    <input
                      type="file"
                      accept="image/*"
                      style={{ display: "none" }}
                      onChange={handleFileChangeAndUploadCallOneOne}
                    />
                  </Button>
                )}
              </Box>
            </Box>
            <Box
              p={2}
              bgcolor="#fff"
              borderRadius={4}
              boxShadow="rgba(0, 0, 0, 0.16) 0px 1px 4px"
              mb={2}
            >
              <Box sx={{ width: "100%" }}>
                <Typography variant="body2" fontWeight={550} mb={2}>
                  Video giới thiệu khóa học:
                </Typography>
                {loadingCirVideo ? (
                  <CircularProgress />
                ) : (
                  <>
                    {mediaSrcVideo && (
                      <>
                        <video
                          src={mediaSrcVideo}
                          controls
                          width="100%"
                        ></video>
                        <Button
                          component="label"
                          variant="contained"
                          color="secondary"
                          sx={{ width: "100%", mt: 1 }}
                        >
                          Thay đổi video
                          <input
                            type="file"
                            accept="video/mp4"
                            style={{ display: "none" }}
                            onChange={handleFileChangeAndUploadCallVideo}
                          />
                        </Button>
                      </>
                    )}
                  </>
                )}
                {showUploadButtonVideo && (
                  <Button
                    component="label"
                    variant="contained"
                    startIcon={<FaUpload />}
                    sx={{
                      width: "100%",
                      height: "150px",
                      background: "transparent",
                      borderRadius: 2,
                      color: "#333",
                      fontWeight: 550,
                      border: "1px dashed",
                      marginBottom: 2,
                      "&:hover": {
                        backgroundColor: "rgba(0,0,0,0.1)",
                      },
                    }}
                  >
                    Tải video
                    <input
                      type="file"
                      accept="video/mp4"
                      style={{ display: "none" }}
                      onChange={handleFileChangeAndUploadCallVideo}
                    />
                  </Button>
                )}
              </Box>
            </Box>
          </Stack>
        </Grid>
      </Grid>

      <Box pb={8}>
        <Button
          size="small"
          onClick={handleSubmit}
          variant="contained"
          sx={{
            bgcolor: "#B32519 !important",
            float: "right",
            textTransform: "none",
            "&:hover": { bgcolor: "#B32519 !important" },
          }}
        >
          Tạo
        </Button>
      </Box>
    </Box>
  );
};

const SelectTeacher = ({ handleChangeCourse, formData }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [teachers, setTeachers] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const observer = useRef<IntersectionObserver | null>(null);

  const fetchTeachers = async (search = "", newPage = 1) => {
    if (loading || (!hasMore && newPage !== 1)) return;

    setLoading(true);
    try {
      const response = await getListUser({
        limit: 10,
        page: newPage,
        user_role: "teacher",
        search,
      });

      const newTeachers = response.data || [];

      if (newPage === 1) {
        setTeachers(newTeachers);
      } else {
        setTeachers((prev) => [...prev, ...newTeachers]);
      }

      setHasMore(newTeachers.length >= 10);
    } catch (error) {
      console.error("Lỗi khi lấy danh sách giáo viên:", error);
    }
    setLoading(false);
  };

  const lastTeacherRef = useCallback(
    (node) => {
      if (loading || !hasMore) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          setPage((prev) => prev + 1);
        }
      });

      if (node) observer.current.observe(node);
    },
    [loading, hasMore]
  );

  useEffect(() => {
    fetchTeachers(searchTerm, page);
  }, [page]);

  useEffect(() => {
    setPage(1);
    fetchTeachers(searchTerm, 1);
  }, [searchTerm]);

  return (
    <Box flex={1} mb={1}>
      <Typography variant="body2" mb={0.5}>
        Chọn giáo viên:
      </Typography>
      <Autocomplete
        value={teachers.find((t) => t._id === formData.teacher_id) || null}
        onChange={(event, newValue) => {
          handleChangeCourse("teacher_id", newValue ? newValue._id : "");
        }}
        inputValue={searchTerm}
        onInputChange={(event, newInputValue) => {
          setSearchTerm(newInputValue);
        }}
        options={teachers}
        getOptionLabel={(option) => option.display_name || ""}
        loading={loading}
        renderOption={(props, option, { index }) => (
          <li
            {...props}
            ref={index === teachers.length - 1 ? lastTeacherRef : null}
          >
            {option.display_name}
          </li>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            size="small"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading && <CircularProgress color="inherit" size={20} />}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "12px !important",
                fontSize: 14,
              },
            }}
          />
        )}
      />
    </Box>
  );
};

export default CreateCourse;
